/**
 * Animation theme values.
 */
import { keyframes } from "@oui/system"

export const ghosted = keyframes`
  0% {
    left: 0;
    opacity: 0.3;
    right: auto;
    width: 0%;
  }
  20% {
    left: 0;
    opacity: 1;
    right: auto;
    width: 100%;
  }
  28% {
    left: auto;
    right: 0;
    width: 100%;
  }
  51% {
    left: auto;
    right: 0;
    width: 0%;
  }
  82% {
    left: auto;
    right: 0;
    width: 100%;
  }
  83% {
    left: 0;
    right: auto;
    width: 100%;
  }
  96% {
    left: 0;
    right: auto;
    width: 0%;
  }
  100% {
    left: 0;
    opacity: 0.3;
    right: auto;
    width: 0%;
  }
`
